<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="企业名称" min-width="180" >
            <template slot-scope="scope">
              {{ scope.row.enterprise_name }}
            </template>
        </el-table-column>
        <el-table-column label="法定代表人">
            <template slot-scope="scope">
              {{ scope.row.legal_person_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="资产总额">
            <template slot-scope="scope">
              {{ scope.row.asset_total || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="负债总额">
            <template slot-scope="scope">
              {{ scope.row.liability_total || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="净利润总额">
            <template slot-scope="scope">
              {{ scope.row.net_profit_total || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="从业人数">
            <template slot-scope="scope">
              {{ scope.row.practice_persons || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="利润总额">
            <template slot-scope="scope">
              {{ scope.row.profit_total || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="营收总额">
            <template slot-scope="scope">
              {{ scope.row.revenue_total || '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'annualReportList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '企业年报',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>